import axios from "axios";
import React, { useState } from "react";
import ReactModal from "react-modal";

function CreaPreguntas(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const [postConsecutivo, setPostConsecutivo] = useState([]);
  const [postPregunta, setPostPregunta] = useState([]);
  const [postRespuesta, setPostRespuesta] = useState([]);
  const [postGrupo, setPostGrupo] = useState([]);
  const postData = (e) => {
    if (postGrupo != "") {
      e.preventDefault(e);
      axios({
        method: "post",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: "https://suadesarrollo.azurewebsites.net/api/CreaPregunta",
        data: {
          encuestaId: props.idEncuesta,
          consecutivo: postConsecutivo,
          pregunta: postPregunta,
          tipoRespuesta: postRespuesta,
          grupo: postGrupo,
        },
      })
        .then((Response) => {
          console.log(Response.data);
          window.alert(Response.data);
        })
        .catch((error) => {
          console.log(error);
          alert("Error al crear" + error);
        });
    } else {
      e.preventDefault(e);
      axios({
        method: "post",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: "https://suadesarrollo.azurewebsites.net/api/CreaPregunta",
        data: {
          encuestaId: props.idEncuesta,
          consecutivo: postConsecutivo,
          pregunta: postPregunta,
          tipoRespuesta: postRespuesta,
          grupo: "0",
        },
      })
        .then((Response) => {
          console.log(Response.data);
          window.alert(Response.data);
        })
        .catch((error) => {
          console.log(error);
          alert("Error al crear" + error);
        });
    }
  };
  return (
    <div>
      <button
        variant="contained"
        className="btn btn-primary "
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Crea Pregunta
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-body">
                  <div class="card-header py-3">
                    <h6 class="m-0 font-weight-bold text-primary">
                      Crear Preguntas
                    </h6>
                  </div>
                  <div class="table-responsive">
                    <form className="user">
                      <div className="form-group row">
                        <div className="col-sm-3">
                          <input
                            type="number"
                            className="form-control form-control-user"
                            placeholder="N° Consecutivo"
                            onChange={(e) => setPostConsecutivo(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <div className="col-sm-12">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Pregunta"
                            onChange={(e) => setPostPregunta(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="col-sm-6">
                          <select
                            className="btn btn-secondary btn-user btn-block"
                            onChange={(e) => setPostRespuesta(e.target.value)}
                          >
                            <option value="">
                              Seleccione tipo de Respuesta
                            </option>
                            <option value="Abierta">Abierta</option>
                            <option value="Seleccion">Selección </option>
                            <option value="Calificacion">Puntaje(1-6)</option>
                            <option value="Paciente">Puntaje (1-3)</option>
                          </select>
                        </div>
                        <div className="col-sm-6">
                          <input
                            type="number"
                            className="form-control form-control-user"
                            placeholder="Grupo al que pertenece"
                            onChange={(e) => setPostGrupo(e.target.value)}
                          />
                        </div>
                      </div>

                      <button
                        className="btn btn-primary btn-user btn-block "
                        onClick={postData}
                      >
                        Guardar
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaPreguntas;
